
      <div class="modal-header">
        <h5 class="modal-title">Change Pasword</h5>
        <button type="button" class="btn-close"  (click)="close()" aria-label="Close"></button>
      </div>
      <div class="modal-body" [formGroup]="userForm">
        <div class="row">
          <div class="col-md-6">
            <label>New Password</label>
            <input type="password" formControlName="Password" class="form-control form-control-sm">
          </div>
          <div class="col-md-6">
            <label>Confirm </label>
            <input type="password" [ngClass]="{'is-valid':passwordsMatching,'is-invalid':!passwordsMatching}" formControlName="Confirm" class="form-control  form-control-sm">
          </div>
        </div>
   

      </div>
      <div class="modal-footer">
        <button (click)="close()" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button (click)="delete()" [disabled]="!IsValid()" type="button" class="btn btn-primary">Change Password</button>
      </div>
